import { render } from "./BroadcastCall.vue?vue&type=template&id=2b5f78d0"
import script from "./BroadcastCall.vue?vue&type=script&lang=js"
export * from "./BroadcastCall.vue?vue&type=script&lang=js"

import "./BroadcastCall.vue?vue&type=style&index=0&id=2b5f78d0&lang=scss"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__